"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickBusy = void 0;
const react_1 = require("react");
const react_use_1 = require("react-use");
const helpers_1 = require("../lib/helpers");
const Journey_1 = require("../lib/Journey");
const JourneyAppContext_1 = require("../contexts/JourneyAppContext");
function useOnClickBusy(onClickFromProps, enabled) {
    const [busy, setBusy] = react_1.useState(false);
    const isMounted = react_use_1.useMountedState();
    const { error, setError } = react_1.useContext(JourneyAppContext_1.JourneyAppContext);
    /* use a ref because state isn't fast enough, if we do multiple clicks quickly, the state var wont update in time. */
    const busyRef = react_1.useRef(false);
    const onClickHandle = react_1.useCallback((e) => {
        if (busy || busyRef.current) {
            e.stopPropagation();
            return;
        }
        const onClickResult = onClickFromProps === null || onClickFromProps === void 0 ? void 0 : onClickFromProps(e);
        if (helpers_1.isPromise(onClickResult)) {
            const onClickPromise = onClickResult;
            setBusy(true);
            busyRef.current = true;
            Journey_1.Journey.startPageLoader();
            return onClickPromise.finally(() => {
                if (isMounted()) {
                    setBusy(false);
                    busyRef.current = false;
                }
                Journey_1.Journey.stopPageLoader();
            }).catch((error) => {
                setError({
                    message: error.message,
                    ref: { current: e.target },
                });
                if (isMounted()) {
                    setBusy(false);
                    busyRef.current = false;
                }
                Journey_1.Journey.stopPageLoader();
            });
        }
    }, [busy, isMounted, onClickFromProps, setError]);
    return {
        onClick: enabled ? onClickHandle : onClickFromProps,
        busy,
    };
}
exports.useOnClickBusy = useOnClickBusy;
